import * as yup from 'yup';
import { ALL_UNITS } from '@/features/units/schema';

export const shoppingListEntrySchema = yup.object({
  ingredient_name: yup.string().required('Ingredient is required'),
  subcategory_id: yup.string().nullable(),
  amount: yup.number().typeError('Amount must be a number').min(0, 'Amount must be at least 0').required('Amount is required'),
  unit: yup.string().oneOf(ALL_UNITS).required('Unit is required'),
  is_bought: yup.boolean().default(false),
  // Only used when the entered name doesn't match an existing ingredient — see isCustomIngredient in AddShoppingListEntryForm.
  kcal: yup.number().typeError('Kcal must be a number').min(0, 'Kcal must be at least 0').required('Kcal is required'),
  protein: yup.number().typeError('Protein must be a number').min(0, 'Protein must be at least 0').required('Protein is required'),
  fat: yup.number().typeError('Fat must be a number').min(0, 'Fat must be at least 0').required('Fat is required'),
  carbs: yup.number().typeError('Carbs must be a number').min(0, 'Carbs must be at least 0').required('Carbs is required'),
  fiber: yup.number().typeError('Fiber must be a number').min(0, 'Fiber must be at least 0').required('Fiber is required'),
  density: yup.number().typeError('Density must be a number').min(0.0001, 'Density must be at least 0').required('Density is required'),
  piece_weight: yup.number().typeError('Piece weight must be a number').min(0, 'Piece weight must be at least 0').nullable(),
  slice_weight: yup.number().typeError('Slice weight must be a number').min(0, 'Slice weight must be at least 0').nullable(),
  package_size: yup.number().typeError('Package size must be a number').min(0, 'Package size must be at least 0').nullable(),
  portion_size: yup.number().typeError('Portion size must be a number').min(0, 'Portion size must be at least 0').nullable(),
});

export function newShoppingListEntry() {
  return {
    ingredient_name: '',
    ingredient_id: null,
    subcategory_id: null,
    amount: 1,
    unit: 'piece',
    is_bought: false,
    kcal: 0,
    protein: 0,
    fat: 0,
    carbs: 0,
    fiber: 0,
    density: 1,
    piece_weight: null,
    slice_weight: null,
    package_size: null,
    portion_size: null,
  };
}

